import React from 'react';
import AnimatedLogo from './AnimatedLogo';

export default function PoweredByBadge() {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 10,
        right: 14,
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        background: 'rgba(5, 13, 28, 0.52)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,0.07)',
        borderRadius: 20,
        padding: '3px 9px 3px 5px',
        userSelect: 'none',
        pointerEvents: 'none',
      }}
    >
      <AnimatedLogo width={28} />

      <div style={{ lineHeight: 1.25 }}>
        <div
          style={{
            fontSize: 8,
            fontWeight: 800,
            color: 'rgba(255,255,255,0.82)',
            letterSpacing: 0.4,
            fontFamily: 'Inter, Arial, sans-serif',
          }}
        >
          CallEssential
        </div>
        <div
          style={{
            fontSize: 7,
            fontWeight: 500,
            color: 'rgba(255,255,255,0.42)',
            letterSpacing: 0.3,
            fontFamily: 'Inter, Arial, sans-serif',
          }}
        >
          by Synergytalk
        </div>
      </div>
    </div>
  );
}
